import { writable, type Writable } from 'svelte/store';
import { API_URL_DEFAULT, TRADE_STATS_API_URL_DEFAULT } from './constants';

export const apiURL: Writable<string> = writable(API_URL_DEFAULT);
export const tradeStatsApiURL: Writable<string> = writable(TRADE_STATS_API_URL_DEFAULT);
